import { SVGProps } from 'react';

const Go = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="8"
        height="23"
        viewBox="0 0 8 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        strokeWidth={1.5}
        style={{ strokeLinejoin: 'round', strokeMiterlimit: 2 }}
        {...props}
    >
        <line
            x1={6.65625}
            y1={4.24268}
            x2={3.82782}
            y2={1.41425}
            strokeLinecap="round"
        />
        <line
            x1={3.82782}
            y1={1.41425}
            x2={0.999396}
            y2={4.24268}
            strokeLinecap="round"
        />
        <line
            x1={3.65625}
            y1={1.5}
            x2={3.65625}
            y2={22}
            strokeLinecap="round"
        />
    </svg>
);

export default Go;
